import { HTMLAttributes, ReactNode } from "react";
import { PageHeaderRoot } from "./PageHeader.styles";

export type PageHeaderVariant = "title" | "panel";

export interface PageHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
	title?: ReactNode;
	actions?: ReactNode;
	children?: ReactNode;
	variant?: PageHeaderVariant;
}

/**
 * Shared visual header for simple title pages and composed order headers.
 * `children` deliberately stays available for existing complex headers.
 */
const PageHeader = ({ title, actions, children, className, variant = "title", ...rest }: PageHeaderProps) => (
	<PageHeaderRoot
		className={className}
		data-page-header-variant={variant}
		variant={variant}
		{...rest}
	>
		{variant === "title" && title && <h1>{title}</h1>}
		{variant === "title" && actions && <div className="page-header-actions">{actions}</div>}
		{children}
	</PageHeaderRoot>
);

export default PageHeader;
